"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var parse5_1 = require("parse5");
var fs = require("fs");
var path = require("path");
var node_1 = require("./node");
function resolveSrc(urlString, options) {
    if (urlString.indexOf('http://') === 0 || urlString.indexOf('https://') === 0)
        return urlString;
    else
        urlString;
    return path.resolve(path.join(path.resolve(options.entry.path), urlString));
}
function __NodeHandler(node, options) {
    node = (0, node_1.Node)(node);
    switch (node.tagName) {
        case "script":
            if (node.getAttribute("src")) {
                if (options.devMode == true)
                    node.setAttribute("data-prewrite-src", node.getAttribute("src"));
                var _resolved = fs.readFileSync(resolveSrc(node.getAttribute("src"), options), "utf-8");
                node.attrs = [{ name: "type", value: node.getAttribute("type") || "text/javascript" }];
                node.childNodes = [
                    {
                        nodeName: "#text",
                        value: _resolved,
                        parentNode: node
                    }
                ];
            }
        case "link":
            if (node.getAttribute("rel") == "stylesheet") {
                if (options.devMode == true)
                    node.setAttribute("data-prewrite-href", node.getAttribute("href"));
                var _resolved = fs.readFileSync(resolveSrc(node.getAttribute("href"), options), "utf-8");
                node = (0, parse5_1.parseFragment)("<style type=\"text/css\">" + _resolved.replace(/\n/g, "") + "</style>").childNodes[0];
            }
    }
    if (node.childNodes) {
        for (var i = 0; i < node.childNodes.length; i++) {
            node.childNodes[i] = __NodeHandler(node.childNodes[i], options);
        }
    }
    return node;
}
function compile(options) {
    var entryFile = path.resolve(options.entry.path + options.entry.file);
    var entry = fs.readFileSync(entryFile, "utf-8");
    var parsed = (0, parse5_1.parse)(entry);
    for (var i = 0; i < parsed.childNodes.length; i++) {
        parsed.childNodes[i] = __NodeHandler(parsed.childNodes[i], options);
    }
    fs.writeFileSync(path.resolve(options.output), (0, parse5_1.serialize)(parsed));
}
function CompileSourceInterface(options) {
    var entryFile = path.resolve(options.entry.path + options.entry.file);
    var __watchFile = function (callback) {
        fs.watchFile(entryFile, function () {
            compile(options);
            callback();
        });
    };
    compile(options);
    return {
        watch: __watchFile
    };
}
exports.default = CompileSourceInterface;
